import { DynamicIconType } from '@allesauto/utils/consts';
import clsx from 'clsx';
import React from 'react';

import './BenefitIcon.css';

import DynamicIcon from '../dynamicIcon';

export interface BenefitIconProps {
  icon: DynamicIconType;
  customClassName?: string;
  isNumeric?: boolean;
}

const BenefitIcon: React.FC<BenefitIconProps> = (props) => {
  const { icon, customClassName = '', isNumeric } = props;
  const className = {
    icon: clsx(
      'benefits-icon flex font-regular',
      isNumeric && 'h-45px w-45px lg:h-[5.625rem] lg:w-[5.625rem]',
      !isNumeric && 'sm:h-30px sm:w-30px lg:h-40px lg:w-40px',
      customClassName
    ),
  };
  return (
    <span className={className.icon}>
      <DynamicIcon icon={icon} />
    </span>
  );
};

export default BenefitIcon;
